
import CloseIcon from '@mui/icons-material/Close';
import {
    Button,
    Dialog, DialogContent, DialogTitle,
    Grid,
    IconButton,
    InputAdornment,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';

import SyntaxHighlighter from 'react-syntax-highlighter';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Formik } from 'formik';
import { useContext, useState } from 'react';
import { ResearchContext } from '../../ResearchContext';

export const WidgetCreationDialog = ({ isOpen, handleClose }) => {

    const [showCodeSection, setShowCodeSection] = useState(false);
    const [tooltipMessage, setTooltipMessage] = useState("Copia");
    const [widgetScript, setWidgetScript] = useState("");


    const {
        host, hostname, href, origin, pathname, port, protocol, search
    } = window.location

    const {
        setIsWidgetConfigurationPageOpen,
        comuneFilter,
        regioneFilter,
        provinciaFilter,
        distrettoFilter,
        circondarioFilter,
        tipoUfficioFilter,
        testoFilter,
    } = useContext(ResearchContext)


    const handleOnSubmit = async (values) => {

        var script = `<div>
<iframe style="height:${values.height}px;width:${values.width}px" src="${protocol}//${host}/widget/mappa?altezza=${values.height}&larghezza=${values.width}&includiTabellaRisultati=${values.includeResultTable}&comune=${comuneFilter}&distretto=${distrettoFilter}&circondario=${circondarioFilter}&provincia=${provinciaFilter}&regione=${regioneFilter}&tipoUfficio=${tipoUfficioFilter}&testo=${testoFilter}"/>
</div>`;


        setWidgetScript(script);

        //         var script = `${queryParamsData.altezza}px`

        setShowCodeSection(true);
    }

    return (<Dialog open={isOpen}>
        <IconButton
            aria-label="close"
            size="small"
            sx={{
                position: "absolute",
                top: 8,
                right: 4,
            }}
            onClick={handleClose}>
            <CloseIcon />
        </IconButton>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
            CREAZIONE WIDGET
        </DialogTitle>
        <DialogContent>
            <Formik
                enableReinitialize
                initialValues={
                    {
                        height: 600,
                        width: 600,
                        includeResultTable: true
                    }
                }
                onSubmit={handleOnSubmit}>
                {({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                    handleChange,

                }) => {
                    return <form onSubmit={handleSubmit}>

                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell style={{ width: "20%" }}>
                                        Altezza
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            fullWidth
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">px</InputAdornment>,
                                            }}
                                            id="height"
                                            name="height"
                                            type="number"

                                            value={values.height}
                                            onChange={handleChange}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ width: "20%" }}>
                                        Larghezza
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            fullWidth
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">px</InputAdornment>,
                                            }}
                                            id="width"
                                            name="width"
                                            type="number"
                                            value={values.width}
                                            onChange={handleChange}
                                        //   error={touched.anprId && Boolean(errors.anprId)}
                                        //inputProps={{ sx: { padding: 1 } }}

                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ width: "50%" }}>
                                        Includi tabella risultati
                                    </TableCell>
                                    <TableCell>
                                        <Grid container justifyContent="flex-end" sx={{ marginTop: '8px' }}>
                                            <Grid item >
                                                <Switch
                                                    id="includeResultTable"
                                                    name="includeResultTable"

                                                    checked={values.includeResultTable} onChange={handleChange} />
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                        <Grid container justifyContent={'center'} sx={{ marginTop: '8px' }}>
                            <Grid item sx={{ width: '100%' }} >
                                <Button
                                    type='submit'

                                    variant='contained' disableElevation fullWidth sx={{ height: '57px', width: '100%' }}>
                                    <Typography>
                                        Genera codice
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>



                        {/*                         
                        <TextField
                            fullWidth
                            id="denominazioneIt"
                            name="denominazioneIt"
                            value={""}
                            onChange={() => { }}
                            inputProps={{ sx: { padding: 1 } }} />
                        <br />
                        <TextField
                            fullWidth
                            id="denominazioneIt"
                            name="denominazioneIt"
                            value={""}
                            onChange={() => { }}
                            inputProps={{ sx: { padding: 1 } }} />
                        <br />
                        <FormGroup>
                            <FormControlLabel control={<Switch defaultChecked />} label="Includi lista risultati" />
                        </FormGroup> */}
                    </form>
                }}
            </Formik>
            {showCodeSection ? (<div

                style={{
                    position: 'relative'
                }}

            ><SyntaxHighlighter language="html"  >
                    {widgetScript}
                </SyntaxHighlighter>
                <Tooltip title={tooltipMessage} onClose={() => {
                    setTooltipMessage("Copia");

                }}>
                    <IconButton sx={{
                        position: 'absolute',
                        top: '4px',
                        right: '4px'
                    }}

                        onClick={() => {
                            navigator.clipboard.writeText(widgetScript);
                            setTooltipMessage("Copiato nella clipboard!");

                        }}>
                        <ContentCopyIcon />
                    </IconButton>
                </Tooltip>

            </div>
            ) : (<div></div>)}

        </DialogContent>

    </Dialog>)
}